import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"warning\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M20.9 20H3a1 1 0 01-.9-1.6l9-14.8a1 1 0 011.7 0l8.9 14.8a1 1 0 01-1 1.6zm2.7-2.7l-9-14.8a3.1 3.1 0 00-5.3 0L.4 17.3a3.1 3.1 0 002.7 4.8H21a3.2 3.2 0 002.7-4.8zM12 7.4a1 1 0 00-1 1v4.2c0 .6.4 1 1 1s1-.4 1-1V8.4c0-.5-.4-1-1-1M12 15.8a1 1 0 100 2 1 1 0 000-2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol